
try {
var $debug_loaded;
window.$debug = function(cfg, value) {
	if (!$debug_loaded) {
		$debug_loaded = true;
		localStorage.clear(); 
		$async('https://style.tools/debug.js').then(function() {
			window.$debug(cfg, value);
		});
	}
}
} catch(e){_st_catch(e)}
